import React, { useState } from 'react';

const benefitOptions = [
  "1. Night time backup support",
  "2. Nursing excellence",
  "3. Improved utilisation of ventilators and ICU beds",
  "4. Physician expertise",
  "5. Digitisation of patient records and access to patient data",
  "6. Treatment of complex cases",
  "7. Reduction in transfer outs",
  "8. Reduction in Length of Stay",
  "9. Increase in ICU Revenue",
  "10. Other"
];

const Page3MultipleChoice = ({ 
  selectedBenefits, 
  toggleBenefit,
  otherBenefit, 
  setOtherBenefit,
  handlePrevious,
  handleNext 
}) => {
  // Add state to track validation error
  const [otherError, setOtherError] = useState(false);

  // Check if form is valid before proceeding
  const handleNextWithValidation = () => {
    // Check if "Other" is selected but the text field is empty
    if (selectedBenefits.includes("10. Other") && !otherBenefit.trim()) {
      setOtherError(true);
      return;
    }
    
    // Clear any error and proceed
    setOtherError(false);
    handleNext();
  };

  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>How has Cloudphysician's services benefited your hospital?</label>
          <p className="instruction-text"> * Please select all that is applicable</p>
          <div className="benefits-list">
            {benefitOptions.map((benefit, index) => (
              <div key={index} className="benefit-item">
                <label className={`checkbox-label left-aligned ${selectedBenefits.includes(benefit) ? 'selected' : ''}`}>
                  <input
                    type="checkbox"
                    checked={selectedBenefits.includes(benefit)}
                    onChange={() => {
                      toggleBenefit(benefit);
                      // Clear error when unchecking "Other"
                      if (benefit === "10. Other" && selectedBenefits.includes(benefit)) {
                        setOtherError(false);
                      }
                    }}
                  />
                  <span>{benefit}</span>
                </label>
                {benefit === "10. Other" && selectedBenefits.includes(benefit) && (
                  <div className="other-input-container">
                    <input
                      type="text"
                      className={`other-input ${otherError ? 'error-input' : ''}`}
                      value={otherBenefit}
                      onChange={(e) => {
                        setOtherBenefit(e.target.value);
                        // Clear error when typing
                        if (e.target.value.trim()) {
                          setOtherError(false);
                        }
                      }}
                      placeholder="Please specify other benefits..."
                    />
                    {otherError && (
                      <p className="error-message">Please specify the other benefit</p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNextWithValidation}
          disabled={selectedBenefits.length === 0}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page3MultipleChoice;
